/**
 * Estado vacío consistente para AdminTableShell.
 *
 * Se renderiza cuando `rows.length === 0` y no hay loading.
 */

import type { ReactNode } from 'react';
import { ADMIN_TOKENS } from './adminTokens';

interface AdminEmptyStateProps {
  message: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export function AdminEmptyState({ message, icon, action }: AdminEmptyStateProps) {
  return (
    <div style={ADMIN_TOKENS.empty.root}>
      {icon && <div style={{ marginBottom: 12, opacity: 0.6 }}>{icon}</div>}
      <div>{message}</div>
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
